import { createElement } from 'react';
import { DATE_FORMAT } from '@app/configs/dateTime';
import { LoanPurposes } from '@app/configs/loanApplication';
import { getLocalDateTime } from '@app/utils/time';
import formatAmount from '@modules/calculator/utils/formatAmount';
import LoanStatus from '../components/loans/LoanStatus';
export const getPastLoanRows = (loan, t) => {
    const loanAmount = parseFloat(loan.amount);
    const collectedAmount = parseFloat(loan.collectedAmount);
    const collectedPercentage = loanAmount > 0 ? Math.round((collectedAmount / loanAmount) * 100) : 0;
    return [
        {
            key: 'id',
            label: t('financing.investing_page_table.id'),
            value: loan.id,
        },
        {
            key: 'createdAt',
            label: t('financing.investing_page_table.creation_date'),
            value: getLocalDateTime(loan.createdAt, DATE_FORMAT.dateDash),
        },
        {
            key: 'status',
            label: t('financing.investing_page_table.status'),
            value: createElement(LoanStatus, { status: loan.status }),
        },
        {
            key: 'purpose',
            label: t('financing.investing_page_table.purpose'),
            value: loan.purpose === LoanPurposes.Empty ? loan.id : t(`financing.loan_purpose.${loan.purpose}`),
        },
        {
            key: 'period',
            label: t('financing.investing_page_table.period'),
            value: `${loan.period} ${t('financing.investing_page_table.months')}`,
        },
        {
            key: 'amount',
            label: t('financing.investing_page_table.requested'),
            value: formatAmount(loan.amount),
        },
        {
            key: 'collectedAmount',
            label: t('financing.borrowing_page.collected'),
            value: `${formatAmount(loan.collectedAmount)} (${collectedPercentage}%)`,
        },
    ];
};
